import { useContext } from "react";

import { AlertContext } from "components/AlertContextProvider";

/** Hook to provide access to the state and state-setter in AlertContext
 * @returns { newAlert } to show a new alert
 * @see AlertContext
 * @example
 * ``` import useAlertContext from "hooks/useAlertContext"```
 *
 * ``` const { newAlert } = useAlertContext();```
 * ```newAlert({message: "This is a success message", color: "success", seconds: 5});```
 * (message is required. color defaults to "danger" and seconds defaults to 5 if no values are provided)
 */
export default function useAlertContext(): {
    newAlert: newAlert;
} {
    const { newAlert } = useContext(AlertContext);

    return { newAlert };
}
